import React from 'react';
import './Features.css';

function Features() {
  const features = [
    {
      icon: '📋',
      title: 'Gestión de Órdenes de Trabajo',
      description: 'Crea, asigna y da seguimiento a todas tus órdenes desde un solo lugar. Sin papeles, sin confusiones.'
    },
    {
      icon: '📅',
      title: 'Agenda y Asignación de Técnicos',
      description: 'Programa y asigna trabajos a tus técnicos de forma inteligente. Optimiza rutas y tiempos.'
    },
    {
      icon: '📱',
      title: 'Sistema Online para Técnicos',
      description: 'Tus técnicos acceden desde cualquier dispositivo. Ven sus trabajos, actualizan estados y suben fotos.'
    },
    {
      icon: '👥',
      title: 'Registro de Clientes',
      description: 'Base de datos completa de clientes con historial de servicios, equipos y reparaciones.'
    },
    {
      icon: '🗺️',
      title: 'Ruta de Servicios',
      description: 'Visualiza en mapa dónde están tus técnicos y optimiza las rutas de servicio.'
    },
    {
      icon: '💰',
      title: 'Presupuestos y Facturación',
      description: 'Genera presupuestos profesionales y facturas directamente desde el sistema.'
    },
    {
      icon: '📊',
      title: 'Reportes y Estadísticas',
      description: 'Analiza el rendimiento de tu equipo, ingresos, tiempos de respuesta y más.'
    },
    {
      icon: '🤖',
      title: 'Agente IA (Plan Completo)',
      description: 'Asistente inteligente que ayuda a programar, responder clientes y optimizar operaciones.'
    }
  ];

  return (
    <section id="features" className="features section">
      <div className="container">
        <h2 className="section-title">¿Qué hace nuestro software?</h2>
        <p className="section-subtitle">
          Todo lo que necesitas para gestionar tu empresa de servicio técnico de forma profesional
        </p>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
        <div className="target-audience">
          <h3>Dirigido a:</h3>
          <div className="audience-tags">
            <span className="tag">🔧 Servicios técnicos de electrodomésticos</span>
            <span className="tag">❄️ Aire acondicionado</span>
            <span className="tag">🧊 Refrigeración</span>
            <span className="tag">⚡ Electrónica</span>
            <span className="tag">🛠️ Mantenimiento general</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
